<template>
  <div v-if="firmwareTypeForm" class="py-8">
    <FirmwareTypePropertiesForm :form="firmwareTypeForm" @on-save="saveFirmwareType" @on-delete="confirmDelete"/>
  </div>
</template>

<script>
import FirmwareTypePropertiesForm from "@/Forms/FirmwareType/FirmwareTypePropertiesForm.vue";
import {mapStores} from "pinia";
import {useFirmwareTypesStore} from "@/stores/firmwareTypes.js";

export default {
  name: "FirmwareTypePropertiesView",
  components: {FirmwareTypePropertiesForm},
  data() {
    return {
      firmwareTypeForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(useFirmwareTypesStore)
  },
  methods: {
    async saveFirmwareType() {
      try {
        const response = await this.firmwareTypeForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.firmware.types.type.properties.firmware_type_properties_view.firmware_type_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, firmwareType: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.firmware.types.type.properties.firmware_type_properties_view.are_you_sure_you_want_to_delete_this_firmware_type'),
        header: this.$t('pages.admin.firmware.types.type.properties.firmware_type_properties_view.delete_firmware_type'),
        accept: () => {
          this.deleteFirmwareType();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.firmware.types.type.properties.firmware_type_properties_view.firmware_type_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deleteFirmwareType() {
      try {
        if (this.$route.params.firmwareType !== 'NEW') {
          await this.firmwareTypesStore.deleteFirmwareType(this.$route.params.firmwareType);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.firmware.types', params: {...this.$route.params, firmwareType: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.firmwareType': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.firmwareType === 'NEW') {
            this.firmwareTypeForm = await this.firmwareTypesStore.createFirmwareType();
          } else {
            this.firmwareTypeForm = await this.firmwareTypesStore.editFirmwareType(this.$route.params.firmwareType);
            this.firmwareTypeForm.id = this.$route.params.firmwareType;
          }
        } else {
          this.firmwareTypeForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>